import React, { useEffect, useState } from "react";
import "../SellerMydeliveredOrders/SellerMydeliveredOrders.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerMyDeliveredOrders() {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem("seller_token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    axios.get(
      `${BaseUrl}${SellerServicesUrl.MyOrders}?status=delivered`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    )
    .then((res) => {
      setOrders(res.data.data || []);
    })
    .catch((err) => {
      console.error(err);
    });

  }, [token, navigate]);

  return (
    <div className="orders-page">
      {/* Sidebar */}
      <aside className="tabs-column">
        <Link to="/seller/sellerconfirmedorders" className="tab">
          المؤكدة
        </Link>

        <Link to="/seller/sellershippedorders" className="tab">
          المشحونة
        </Link>

        <Link to="/seller/sellermydeliveredorders" className="tab active">
          المكتملة ({orders.length})
        </Link>
      </aside>

      {/* Main */}
      <div className="delivered-wrapper container">
        <div className="completed-box">
          <div className="completed-statusdelivered">
            تم التسليم
          </div>

          {orders.length === 0 && (
            <p className="text-center">لا توجد طلبات مكتملة</p>
          )}

          {orders.map((order) => (
            <div
              key={order.id}
              className="completed-card"
              onClick={() =>
                navigate(`/seller/orderdetails/${order.id}`)
              }
              style={{ cursor: "pointer" }}
            >
              <div className="completed-contentdelivered">
                <img
                  src={order.products?.[0]?.image}
                  alt=""
                  className="completed-img"
                />

                <div className="completed-text-wrapper">
                  <h5 className="completed-title">
                    {order.products?.[0]?.name}
                  </h5>

                  <p className="completed-desc">
                    {order.products?.[0]?.description}
                  </p>

                  <div className="price-center">
                    <p className="mydeliverorder-price">
                      {order.total} ر.س
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}
